import React, { useState } from "react";
import SVG from "react-inlinesvg";
import { Button, Image, Row, Col, Table, Modal } from "react-bootstrap";
import { SliderReusableComponent } from "../../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Scrollbars from "react-custom-scrollbars";
import { NavLink } from "react-router-dom";
import Media from "react-media";
import { MobileTopHeader } from "../../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

export const SelectedItems = (props) => {
  const [nextStepModal, setNextStepModal] = useState(false);
  const handleCloseZNextStepModal = () => {
    setNextStepModal(false);
  };
  const handleShowZNextStepModal = () => {
    setNextStepModal(true);
  };
  const onWithOutApiCall = (e) => {
    props.history.push({
      pathname: "/casual-fine-dining/menusetup",
    });
  };
  const [state, setState] = useState({ global: "", catalog: "" });
  const handleChangeCategory = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
    
  };
  const displayMain = () => {
    return (
      <div
        className={`${
          !props.dash && `onboarding_process_screen-button-map`
        } d-flex justify-content-between flex-column`}
      >
        <div>
          <TopTextReusableComponent
            headingText="Menu Set Up"
            headingParagraph="Manage your food items"
          />
        </div>
        <div className="mt-4 enGlobleCatelogueModalList d-flex align-items-center justify-content-between mb-4">
          <div className="d-flex align-items-center">
            <div className="enCatelogueIconDiv">
              <SVG
                width="27px"
                src={require("../../../../../../../../assets/images/UserManagement/menuicon.svg")}
              />
            </div>
            <div className="f14-500 px-3">Catalogue Menu 1</div>
          </div>
          <div className="d-flex align-items-center pr-3">
            <div className="f14-500 pr-5">ID : #001</div>
            <Button variant="link" className="enIconBtn">
              <Image
                src={require("../../../../../../../../assets/images/UserManagement/Delete.svg")}
                alt="Delete"
                title="Delete"
                fluid
              />
            </Button>
          </div>
        </div>
        <Row>
          <Media query="(min-width: 992px)">
            <Col lg={5}>
              <Row>
                <Col md={6} className="pr-md-1">
                  <div className="bg-white enP075rem small f10-500">
                    Global Catalogue
                  </div>
                  <Scrollbars style={{ width: "100%", height: 500 }}>
                    <div className="enCategoryList small h-100 p-1">
                      <button type="button" className={`f11-700 active`}>
                        Arabic
                      </button>
                      <button type="button" className={`f11-700 `}>
                        Chinese
                      </button>
                      <button type="button" className={`f11-700 `}>
                        Sindhi
                      </button>
                    </div>
                  </Scrollbars>
                </Col>
                <Col md={6} className="pl-md-0">
                  <div className="bg-white enP075rem small f10-500">
                    Categories
                  </div>
                  <Scrollbars style={{ width: "100%", height: 500 }}>
                    <div className="enCategoryList small h-100 p-1">
                      <button type="button" className={`f11-700 active`}>
                        Desserts
                      </button>
                      <button type="button" className={`f11-700 `}>
                        Beverages
                      </button>
                      <button type="button" className={`f11-700 `}>
                        Startters
                      </button>
                    </div>
                  </Scrollbars>
                </Col>
              </Row>
            </Col>
          </Media>
          <Media query="(max-width: 991px)">
            <Col xs={12} className="pt-3">
              <Row>
                <Col xs={6}>
                  <FormControl variant="outlined" className={"w-100"}>
                    <InputLabel htmlFor="outlined-globalCatalogue">
                      Global Catalogue
                    </InputLabel>
                    <Select
                      value={state.global}
                      id="globalCatalogue"
                      onChange={handleChangeCategory}
                      label="Global Catalogue"
                      inputProps={{
                        name: "globalCatalogue",
                        id: "outlined-globalCatalogue",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value={"arabic"}>Arabic</option>
                      <option value={"chinese"}>Chinese</option>
                      <option value={"sindhi"}>Sindhi</option>
                    </Select>
                  </FormControl>
                </Col>
                <Col xs={6}>
                  <FormControl variant="outlined" className={"w-100"}>
                    <InputLabel htmlFor="outlined-categories">
                      Categories
                    </InputLabel>
                    <Select
                      value={state.catalog}
                      id="categories"
                      onChange={handleChangeCategory}
                      label="categories"
                      inputProps={{
                        name: "categories",
                        id: "outlined-categories",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value={"desserts"}>Desserts</option>
                      <option value={"beverages"}>Beverages</option>
                      <option value={"startters"}>Startters</option>
                    </Select>
                  </FormControl>
                </Col>
              </Row>
            </Col>
          </Media>
          <Col lg={7} className="text-right pl-lg-0">
            <div className="user-table-reusable-superadmin table-responsive mobile_table">
              <Table className="enTable450 HideShowTable text-left">
                <thead>
                  <tr className="super_admin_all_users_table_head rounded-0">
                    <th className="f12-700" style={{ width: "25%" }}>
                      Item ID
                    </th>
                    <th className="f12-700" style={{ width: "30%" }}>
                      Item Name
                    </th>
                    <th className="f12-700" style={{ width: "45%" }}>
                      Description
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="super_admin_all_users_table_body">
                    <td style={{ width: "25%" }}>
                      <div className="f11-500">#ID124563</div>
                      <div className="enIMG33 mt-2 rounded">
                        <Image
                          src={require("../../../../../../../../assets/images/UserManagement/items.png")}
                          alt="View"
                          title="View"
                          fluid
                          width="100%"
                          height="100%"
                        />
                      </div>
                    </td>
                    <td style={{ width: "30%" }}>
                      <div className="d-flex mt-2 align-items-center">
                        <Image
                          src={require("../../../../../../../../assets/images/UserManagement/veg.svg")}
                          alt="Veg"
                          title="Veg"
                          fluid
                          width="16px"
                          className="vegIcon"
                        />
                        <div className="f11-500 pl-2">Italian pizza</div>
                      </div>
                      <hr />
                      <div className="d-flex mt-2 align-items-center">
                        <Image
                          src={require("../../../../../../../../assets/images/UserManagement/vegan.svg")}
                          alt="Vegan"
                          title="Vegan"
                          fluid
                          width="16px"
                          className="vegIcon"
                        />
                        <div className="f11-500 pl-2">Vegan</div>
                      </div>
                    </td>
                    <td style={{ width: "45%" }}>
                      <div className="f11-400">
                        Tomato fillet, basil olive oil
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
        <div className="mobile-center onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
          <div>
            <ReusableOnboardingLink
              buttonTitle="Back Button"
              buttonClass="btn-lg btn btn-outline-secondary"
              buttonText="Cancel"
              link="/casual-fine-dining/menusetup/selectmenu/selectitems"
            />
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
              buttonText="Set Up Done"
              buttonType="Submit"
              onClick={handleShowZNextStepModal}
            />
          </div>
          <div className="d-flex justify-content-end ml-2 ml-xl-5 positionMobileUploadMenu">
            <NavLink
              to="/casual-fine-dining/menusetup/uploadmenu"
              className="f12-700 text-red cursor p-0 bg-transparent border-0"
            >
              Upload Menu
            </NavLink>
            <span className="f10-400 ml-2">
              Leave Rest to us
              <br />
              Charges May Apply
            </span>
          </div>
        </div>
      </div>
    );
  };
  return (
    <React.Fragment>
      <div className="container-fluid">
        {props.dash ? (
          displayMain()
        ) : (
          <div className="row">
            <div
              id="onboarding-scrollbar"
              className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
            >
              <Media query="(min-width: 992px)">
                <div className="col-12">
                  <BackLogoIconButton
                    displayBackText={true}
                    displayArrow={true}
                    backButtonClicked={
                      "/casual-fine-dining/menusetup/selectmenu/selectitems"
                    }
                    notDisplaProgressBar={true}
                  />
                </div>
              </Media>
              <Media query="(max-width: 991px)">
                <MobileTopHeader
                  link={true}
                  onLink={
                    "/casual-fine-dining/menusetup/selectmenu/selectitems"
                  }
                />
              </Media>
              {displayMain()}
            </div>
            <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                // displayBarButton={false}
                displayHamburger={true}
                headingText="Menu Set Up"
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={require("../../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-01.svg")}
              />
            </div>
          </div>
        )}
      </div>
      <Modal
        show={nextStepModal}
        onHide={handleCloseZNextStepModal}
        centered
        className="xl-width-750"
        keyboard={false}
        backdrop={"static"}
      >
        <Modal.Header className="px-4 border-0" closeButton>
          <div className="w-100">
            <Modal.Title className="f16-700 pb-2">Success</Modal.Title>
            <p className="f11-400">You have successfully set up your menu!</p>
            <p className="f11-400 text-gray my-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod temporLorem ipsum dolor sit amet, consectetur adipiscin
            </p>
            <Image
              src={require("../../../../../../../../assets/images/illustratorImage/success.svg")}
              alt="Success"
              title="Success"
              fluid
              width="240px"
            />
          </div>
        </Modal.Header>
        <Modal.Body className="px-4">
          <Button
            variant="danger"
            className="btn150px btn-lg px-5"
            onClick={onWithOutApiCall}
          >
            Okay
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
